import { render, staticRenderFns } from "./SearchResultSnippet.vue?vue&type=template&id=61361e8e"
import script from "./SearchResultSnippet.vue?vue&type=script&lang=js"
export * from "./SearchResultSnippet.vue?vue&type=script&lang=js"
import style0 from "./SearchResultSnippet.vue?vue&type=style&index=0&id=61361e8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports